export default __webpack_public_path__ + "static/media/image-hero-mobile.de7e16b7.png";